// Using IntersectionObserver
if ('IntersectionObserver' in window) { // Detect support for IntersectionObserver
  const observerConfig = {
    root: null, // Viewport
    // rootMargin: '0px', // Does not work with viewport
    threshold: 0 // % visible - target intersection ratio
  }
  // Define observed targets
  const animateElement = '.a-blockquote, .m-box, .m-card, .m-figure' // Defined in /scss/molecule/_animate.scss
  const targets = document.querySelectorAll(animateElement)
  // Observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      // Deal with every intersection
      if (entry.isIntersecting) {
        entry.target.classList.add('js-animate')
      } else {
        entry.target.classList.remove('js-animate')
      }
    })
  }, observerConfig)
  // Observe targets
  targets.forEach(target => {
    observer.observe(target)
  })
} else {
  // If Intersection Observer API is not available
  const animateFallback = document.querySelectorAll(animateElement)
  // For now we simply set the visibility to visible
  animateFallback.forEach(reveal => {
    reveal.setAttribute('style', 'visibility: visible')
  })
}
